<section class="panel-message has-pos-abs">
  <div class="content text-center">
    <ng-content></ng-content>
  </div>
</section>
